export default "__VITE_ASSET__YkpmMMuK__"